import { Image, Typography } from 'antd';
import moment from 'moment';
import React from 'react';

import { RealtimeMessages } from '@/types/database/realtimeMessages';

import styles from './index.module.scss';

const Message: React.FC<{
  message: RealtimeMessages[number];
  type: 'sent' | 'received';
}> = ({ message, type }) => {
  return (
    <div
      className={
        styles[type === 'received' ? 'receivedMessage' : 'sentMessage']
      }
    >
      {type !== 'sent' && (
        <Typography.Text>{message.sender.name}</Typography.Text>
      )}
      <div className={styles.content}>
        {message.content.type === 'text' && <p>{message.content.text}</p>}
        {message.content.type === 'image' && (
          <Image src={message.content.image} alt="message" />
        )}
      </div>
      <Typography.Text>
        {moment(message.createdTime).format('YY-M-D HH:mm:ss')}
      </Typography.Text>
    </div>
  );
};

export default Message;
